import React, { useRef } from "react";
import CanvasDraw from "react-canvas-draw";
import URL from "../../../constant/URL";
import TYPE from "../../../constant/TYPE";
import http from "../../../http/http";
import Button from "../../common/Button";

const Notepad = ( props ) => {

  const canvasDraw = useRef();

  const onChange = () => {
    props.onChange( 0 );
  };

  const onArrow = ( event ) => {
    onClear();
    props.onArrow( `${ event.target.dataset.latex }?${ Date.now() }` );
  };

  const onClear = () => {
    canvasDraw.current.clear();
  };

  const onSubmit = () => {
    http.request( {
      url : URL.API.SELVAS,
      method : http.METHOD.POST,
      type : http.TYPE.SELVAS,
      data : {
        apiKey : '',
        maxCandidateCount : 1,
        range : TYPE.RECOGNIZE_RANGE.MIDDLE.TYPE1,
        inks : canvasDraw.current.lines.map( v => ( { x : v.points.map( v => v.x ), y : v.points.map( v => v.y ) } ) )
      },
      success : ( data ) => {
        props.onSubmit( data );
      }
    } );
  };

  return (
    <div style={ { width : '60%' } }>
      <CanvasDraw
        style={ { border : '1px solid' } }
        ref={ canvasDraw }
        canvasWidth="100%"
        canvasHeight="500px"
        hideInterface={ true }
        lazyRadius={ 0 }
        brushRadius={ 3 }
      />
      <div style={ { height : 5 } } />
      <Button className="btn btn-red" style={ { width : 195 } } onClick={ onChange }>Keypad Change</Button>
      <span style={ { padding : 2.5 } } />
      <Button className="btn btn-blue" style={ { width : 60 } } data-latex="<" onClick={ onArrow }>{ '<' }</Button>
      <span style={ { padding : 2.5 } } />
      <Button className="btn btn-blue" style={ { width : 60 } } data-latex=">" onClick={ onArrow }>{ '>' }</Button>
      <span style={ { padding : 2.5 } } />
      <Button className="btn btn-red" style={ { width : 80 } } onClick={ onClear }>Clear</Button>
      <span style={ { padding : 2.5 } } />
      <Button className="btn btn-red" style={ { width : 100 } } onClick={ onSubmit }>Submit</Button>
    </div>
  );

};

export default Notepad;
